import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Bookmark, Play } from 'lucide-react';
import { api } from '../context/AuthContext';
import './Settings.css';

const SavedVideos = () => {
  const navigate = useNavigate();
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const data = await api('/api/users/me/saved');
        setVideos(data.videos || []);
      } catch { setVideos([]); }
      setLoading(false);
    })();
  }, []);

  return (
    <div className="settings-container" data-testid="saved-videos-page">
      <div className="settings-header">
        <button className="settings-back-btn" onClick={() => navigate('/settings')} data-testid="saved-back-btn">
          <ArrowLeft size={24} />
        </button>
        <h1 className="settings-title">Saved</h1>
      </div>

      {loading ? (
        <div style={{ padding: 40, textAlign: 'center', color: '#6B7280' }}>Loading…</div>
      ) : videos.length === 0 ? (
        <div style={{ padding: '48px 24px', textAlign: 'center', color: '#4B5563' }}>
          <Bookmark size={48} strokeWidth={1.4} style={{ margin: '0 auto 16px', display: 'block', opacity: 0.5 }} />
          <p style={{ fontSize: 16, fontWeight: 600, color: '#1F2937', margin: 0 }}>No saved videos yet</p>
          <p style={{ fontSize: 14, marginTop: 8 }}>Tap the bookmark on any video in your feed to save it here.</p>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: 8, padding: 12 }}>
          {videos.map(v => (
            <div
              key={v.id}
              onClick={() => navigate('/', { state: { videoId: v.id } })}
              data-testid={`saved-video-${v.id}`}
              style={{ position: 'relative', paddingTop: '150%', borderRadius: 10, overflow: 'hidden', background: '#111', cursor: 'pointer' }}
            >
              {v.thumbnail ? (
                <img src={v.thumbnail} alt={v.description || 'video'}
                     style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : null}
              <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(180deg, transparent 50%, rgba(0,0,0,0.7) 100%)' }} />
              <div style={{ position: 'absolute', bottom: 8, left: 8, right: 8, color: '#fff', fontSize: 12, lineHeight: 1.3, textShadow: '0 1px 2px rgba(0,0,0,0.6)' }}>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 4, marginBottom: 4 }}>
                  <Play size={12} fill="#fff" /> <strong>{v.view_count || 0}</strong>
                </div>
                <div style={{ fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{v.username}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SavedVideos;
